import * as _ from 'lodash';

export const getErrorMessage = (response) => {
  if (typeof response === 'string') return response;
  return _.get(response, 'response.data.errMessage', 'An error happened, please try again!');
};

const Countries = {};

const CountryFlagEmoji = {};

require('../data/countries.json').forEach((country) => {
  Countries[country.cca2] = country;
});

require('../data/country-flag-emoji.json').forEach((country) => {
  CountryFlagEmoji[country.code] = country.emoji;
});

export const getCountryFlagEmoji = (cca2) => CountryFlagEmoji[cca2] || '🏁';

export const getCallingCodeOfCountry = (cca2) => Countries[cca2]?.callingCode[0] || '';

export const standardizePhoneNumber = (phoneInput) => {
  return parseInt(phoneInput.replace(/-/g, '').replace(/ /g, '').replace(/\(/g, '').replace(/\)/g, ''));
};

export const getPhoneNumber = ({ phoneNumberCountryCode, phoneNumberUserInput }) => {
  const phoneNumberCallingCode = getCallingCodeOfCountry(phoneNumberCountryCode);
  let parsedPhoneInput = `${standardizePhoneNumber(phoneNumberUserInput)}`;
  if (parsedPhoneInput.substr(0, `${phoneNumberCallingCode}`.length) === `${phoneNumberCallingCode}`) {
    parsedPhoneInput = parsedPhoneInput.substr(`${phoneNumberCallingCode}`.length);
  }
  return `+${phoneNumberCallingCode}${parsedPhoneInput}`;
};

export const COUNTRY_LIST = Countries;
